import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "green-rounded-checkbox",
  "use": "green-rounded-checkbox-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"green-rounded-checkbox\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#2BAB20\" cx=\"11\" cy=\"11\" r=\"11\" /><path stroke=\"#FFF\" stroke-width=\"1.6\" d=\"M16.555 7l-7.492 8L5 10.91\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol